import { render, staticRenderFns } from "./ProductList.vue?vue&type=template&id=27bbe663&"
import script from "./productlist.js?vue&type=script&lang=js&"
export * from "./productlist.js?vue&type=script&lang=js&"
import style0 from "./ProductList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports